export function cerberusStatus(value) {
  const status =
    (typeof value !== "number" && typeof value !== "string") || String(value).trim() === ""
      ? null
      : Number(value);
  if (status === 1) return { status, label: "Activo", color: "success" };
  if (status === 0) return { status, label: "Inactivo", color: "default" };
  if (status === -1) return { status, label: "Eliminado", color: "error" };
  return { status: null, label: "Sin información", color: "default" };
}

export function parseStreamUrl(value) {
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol) ? url : null;
  } catch {
    return null;
  }
}

export function normalizeCerberusLogs(response) {
  const payload = Array.isArray(response) ? response : response?.data;
  const rows = Array.isArray(payload)
    ? payload
    : payload &&
      typeof payload === "object" &&
      ("id" in payload || "ip" in payload || "name" in payload)
    ? [payload]
    : null;
  if (!rows || response?.success === false)
    throw new Error("La respuesta no contiene una lista válida de registros Cerberus.");
  return rows
    .map((row) => {
      if (
        !row ||
        typeof row !== "object" ||
        Array.isArray(row) ||
        !("id" in row || "ip" in row || "name" in row)
      )
        throw new Error("Se recibió un registro Cerberus inválido.");
      const status = cerberusStatus(row.status);
      const ip = typeof row.ip === "string" ? row.ip.trim() : "";
      const url = parseStreamUrl(ip);
      return {
        id: row.id ?? null,
        name: typeof row.name === "string" ? row.name : "",
        ip,
        metadata: row.metadata && typeof row.metadata === "object" ? row.metadata : {},
        status: status.status,
        statusText: status.label,
        statusColor: status.color,
        isActive: status.status === 1,
        userId: row.user_id ?? null,
        more: row.more ?? null,
        createdAt: row.createdAt ?? null,
        updatedAt: row.updatedAt ?? null,
        deletedAt: row.deletedAt ?? null,
        hostname: url?.hostname || ip,
        protocol: url?.protocol.replace(":", "") || null,
        port: url?.port || null,
        streamUrl: url ? ip : null,
      };
    })
    .sort((a, b) => {
      const time = (value) => {
        const date = Date.parse(value);
        return Number.isFinite(date) ? date : 0;
      };
      return time(b.createdAt) - time(a.createdAt);
    });
}

export function formatCerberusDate(value) {
  if (!value) return "Sin registro";
  if (typeof value !== "string") return "Fecha inválida";
  const normalized = value.replace(/ (\d\d:\d\d:\d\d(?:\.\d+)?) ([+-]\d\d)(\d\d)$/, "T$1$2:$3");
  if (!/(Z|[+-]\d{2}:?\d{2})$/i.test(normalized)) return `${value} (sin zona horaria)`;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return "Fecha inválida";
  return new Intl.DateTimeFormat("es-CO", {
    timeZone: "America/Bogota",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).format(date);
}

export function filterCerberusLogs(rows, filters) {
  const query = filters.busqueda.trim().toLowerCase();
  return rows.filter(
    (row) =>
      (!query ||
        [row.name, row.ip, row.id, row.hostname].some((value) =>
          String(value ?? "")
            .toLowerCase()
            .includes(query)
        )) &&
      (filters.ip === "todos" || row.hostname === filters.ip) &&
      (filters.status === "todos" ||
        { activos: 1, inactivos: 0, eliminados: -1, desconocidos: null }[filters.status] ===
          row.status)
  );
}
